import { useState } from 'react'
import { Category } from '@/types/common-types'

interface Props {
	categories: Category[]
	setOpen?: (bool: boolean) => void
}

export default function CategoriesList({ categories, setOpen }: Props) {
	const [language, setLanguage] = useState<'English' | 'Spanish'>('English')

	const categoryGroups = [
		'Student Consumables',
		'Small Group',
		'School Materials',
		'Circulating Libraries',
		'Classroom Libraries'
	]

	function closeModal() {
		if (setOpen) return setOpen(false)
	}

	return (
		<div>
			<div className="flex gap-4 p-4">
				<button
					onClick={() => setLanguage('English')}
					className={`${
						language === 'English' ? 'border-ab-100 font-medium text-ab-100' : ''
					} w-full cursor-pointer border py-2 text-center hover:border-ab-100 hover:text-ab-100`}
				>
					English
				</button>
				<button
					onClick={() => setLanguage('Spanish')}
					className={`${
						language === 'Spanish' ? 'border-ab-100 font-medium text-ab-100' : ''
					} w-full cursor-pointer border py-2 text-center hover:border-ab-100 hover:text-ab-100`}
				>
					Spanish
				</button>
			</div>
			{categoryGroups.map((group) => {
				return (
					<div key={group} className="p-4">
						<h4 className="tracking-wider text-ab-100">{group}</h4>
						{categories
							.filter((category) => category.language === language)
							.filter((category) => category.categoryGroup === group)
							.map((category) => {
								return (
									<CategoryListItem
										closeModal={closeModal}
										key={category.sys.id}
										category={category}
									/>
								)
							})}
					</div>
				)
			})}
		</div>
	)
}

interface CategoryListItemProps {
	category: Category
	closeModal: () => void
}

const CategoryListItem = ({ category, closeModal }: CategoryListItemProps) => {
	return (
		<a key={category.sys.id} href={`#${category.slug}`} onClick={closeModal}>
			<div className="flex cursor-pointer items-center rounded-lg py-3 px-4 transition duration-150 ease-in-out hover:bg-slate-100 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50">
				<div>
					<p className="text-sm font-medium text-slate-700">{category.name}</p>
				</div>
			</div>
		</a>
	)
}
